import * as React from 'react';

import {Atom, Plugins, withMeta, withSystem} from '@packages/systems/wfdl';
import {
  iconName,
  qualify,
  pluginName,
  typeName,
} from '@packages/systems/wfdl-Qualified';
import {TListOfElement, TTypeConstructor} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {getChildren} from '@packages/utilities/data-utils';

const Container = Atom.createRender(
  ({attributes, classes, generateAttributes, data, renderChild}) => {
    // @ts-expect-error - TS18046 - 'data' is of type 'unknown'.
    const Tag = data.tag ?? 'div';
    const containerClasses = classes.push('w-container');

    return (
      <Tag {...generateAttributes(attributes, containerClasses)}>
        {getChildren(data).map((child) => renderChild(child))}
      </Tag>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Container',
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'block',
          marginLeft: 'auto',
          marginRight: 'auto',
          maxWidth: px(940),
        },
      },
      medium: {
        noPseudo: {
          maxWidth: px(728),
        },
      },
      small: {
        noPseudo: {
          maxWidth: 'none',
        },
      },
    },
  },
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Div')),
  },
  showEmpty: true,
  render: Container,
  fields: {
    children: TListOfElement,
    tag: withMeta(
      {variant: 'menu'},
      withSystem(
        {
          defaultValue: 'div',
          label: 'Tag',
          private: true,
          isLocalizable: true,
        },
        TTypeConstructor(qualify(pluginName('Basic'), typeName('TagsDropdown')))
      )
    ),
  },
});

export default config;
